// extracted by mini-css-extract-plugin
export default {"content":"Header_content__FGe6O"};